import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

interface StyledEditableFieldButtonProps {
  isConfirm?: boolean;
  isHidden?: boolean;
}
export const EditableFieldButton = styled.button<StyledEditableFieldButtonProps>`
  width: 32px;
  visibility: ${({ isHidden }) => (isHidden ? 'hidden' : 'visible')};
  height: 32px;
  min-width: 32px;
  margin-left: 8px;
  z-index: 1000;

  background: ${({ isConfirm }) =>
    isConfirm ? beam.color.primaryBlue : beam.color.pureWhite};
  border: none;
  /* small-shadow */
  box-shadow: ${({ isConfirm }) =>
    isConfirm
      ? '0 1px 4px rgba(19, 113, 254, 0.7)'
      : '0 1px 4px rgba(0, 0, 0, 0.161)'};
  border-radius: 8px;
`;

export const FlexRowContainer = styled.div`
  /* Layout Properties */
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-content: center;
  align-items: center;
`;

export const Icon = styled.img<StyledEditableFieldButtonProps>`
  color: ${({ isConfirm }) =>
    isConfirm ? beam.color.pureWhite : beam.color.pureBlack};
`;
interface StyledEditableFieldButtonProps {
  isHidden?: boolean;
  isNotDate?: boolean;
}
export const Container = styled.div<StyledEditableFieldButtonProps>`
  display: flex;
  align-items: center;
  width: ${({ isHidden }) => (isHidden ? 'auto' : '16vw')};
  overflow: ${({ isHidden, isNotDate }) =>
    isHidden && isNotDate ? 'hidden' : 'unset'};
  & div {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;

    margin-bottom: 0;
    white-space: nowrap;
    color: ${beam.font.link};
  }
`;
export const ContainerSidebar = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  width: 100%;
`;
interface DateDivProps {
  width?: number;
  isHidden?: boolean;
}
export const EditableInput = styled.input<DateDivProps>`
  font-family: 'Poppins', sans-serif;
  white-space: nowrap;

  color: ${beam.font.primary};
  background: #fff;
  cursor: text;
  min-width: 80px;
  max-width: 100%;
  border: ${({ isHidden }) => (isHidden ? 'none' : '1px solid #e9edf1')};
  box-sizing: border-box;
  box-shadow: ${({ isHidden }) =>
    isHidden ? 'none' : '0 1px 4px rgba(0, 0, 0, 0.161)'};
  border: none;
  border-radius: 8px;
  background: ${beam.color.pureWhite};
  height: 32px;
  max-height: 32px;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex: 1;
  padding-left: 8px;
  padding-right: 8px;

  -webkit-appearance: none;
  :hover {
    background: ${({ isHidden }) =>
      isHidden ? beam.background.card : 'transparent'};
  }
`;
export const BigEditableInput = styled.textarea<DateDivProps>`
  align-items: flex-start;
  min-height: 120px;
  width: 100%;
  overflow: hidden;
  line-height: 20px;
  resize: none;
  font-family: 'Poppins', sans-serif;

  color: ${beam.font.primary};
  background: #fff;
  cursor: text;
  min-width: 80px;
  max-width: 100%;
  border: ${({ isHidden }) => (isHidden ? 'none' : '1px solid #e9edf1')};
  box-sizing: border-box;
  box-shadow: ${({ isHidden }) =>
    isHidden ? 'none' : '0 1px 4px rgba(0, 0, 0, 0.161)'};
  border: none;
  border-radius: 8px;
  background: ${beam.color.pureWhite};
  height: 32px;
  max-height: 32px;
  display: flex;
  flex: 1;
  padding-left: 8px;
  padding-right: 8px;

  -webkit-appearance: none;
  :hover {
    background: ${({ isHidden }) =>
      isHidden ? beam.background.card : 'transparent'};
  }
`;
